export default __webpack_public_path__ + "static/media/Three.c55bc136.svg";